





























import {SSMLHandler,SSMLhandlerEvent} from '@/lib/SSMLHandler';
import {SpeechSynthesizer} from '@/lib/SpeechSynthesizer';
import {MicIcon, MicOffIcon, PlayIcon} from 'vue-feather-icons';
import {
  Action,
  ActionType,
  SpeechAction,
  RequestType,
  ClientEvent,
  WebRequest,
  WebResponse,
  BrowserDetector,
  SpeechSynthesizerEvent,
  SpeechRecognizerEvent } from 'jovo-client-web-vue';
import { Component, Vue } from 'vue-property-decorator';
import SendIcon from 'vue-feather-icons/icons/SendIcon';

@Component({
  name: 'embedded-chat-bottom',
  components: {
    SendIcon,
    MicIcon,
    MicOffIcon,
    PlayIcon
    },
})
export default class EmbeddedChatBottom extends Vue {
  inputValue = '';
  micOn = false;
  speakOn = false;
  clicked = false;
  isChrome = BrowserDetector.isChrome();
  ssmlHandler : SSMLHandler = new SSMLHandler(this.$client, new SpeechSynthesizer(this.$client.config.speechSynthesizer) );

  async mounted() {
    this.$client.on(ClientEvent.Request, this.onRequest);
    this.$client.on(ClientEvent.Action, this.onAction);
    this.ssmlHandler.$speechSynthesizer.on(SpeechSynthesizerEvent.Speak, this.onSpeechSpeak);
    this.ssmlHandler.on(SSMLhandlerEvent.End, this.endSSMLSpeak);
    this.$client.$speechRecognizer.on(SpeechRecognizerEvent.Start, this.startReco);
    this.$client.$speechRecognizer.on(SpeechRecognizerEvent.Stop, this.stopReco);
    this.$client.$speechRecognizer.on(SpeechRecognizerEvent.Timeout, this.timeOutReco);
    this.$client.$speechRecognizer.on(SpeechRecognizerEvent.Error, this.errorReco);
    this.$client.$speechRecognizer.on(SpeechRecognizerEvent.StartDetected, this.speakReco);
    this.$client.$speechRecognizer.on(SpeechRecognizerEvent.SilenceDetected, this.silenceReco);
    //document.getElementsByTagName("input")[0].focus();
    window.addEventListener('keydown', this.onKeyDown);
    await this.initialize();
  }

  beforeDestroy() {
    this.ssmlHandler.stop();
    this.$client.off(ClientEvent.Request, this.onRequest);
    this.$client.off(ClientEvent.Action, this.onAction);
    this.ssmlHandler.$speechSynthesizer.off(SpeechSynthesizerEvent.Speak, this.onSpeechSpeak);
    this.ssmlHandler.off(SSMLhandlerEvent.End, this.endSSMLSpeak);
    this.$client.$speechRecognizer.off(SpeechRecognizerEvent.Start, this.startReco);
    this.$client.$speechRecognizer.off(SpeechRecognizerEvent.Stop, this.stopReco);
    this.$client.$speechRecognizer.off(SpeechRecognizerEvent.Timeout, this.timeOutReco);
    this.$client.$speechRecognizer.off(SpeechRecognizerEvent.Error, this.errorReco);
    this.$client.$speechRecognizer.off(SpeechRecognizerEvent.StartDetected, this.speakReco);
    this.$client.$speechRecognizer.off(SpeechRecognizerEvent.SilenceDetected, this.silenceReco);
    window.removeEventListener('keydown', this.onKeyDown);
  }

  private async initialize() {
    if (!this.$client.isInitialized) {
      await this.$client.initialize();
      if(this.$route.query.demo)
          await this.$client.createRequest({ type: RequestType.Launch, body: { text: this.$route.query.demo.toString()} }).send();
        else
          await this.$client.createRequest({ type: RequestType.Launch }).send();
    }
  }

  private focus(){
//    (this.$refs.input as HTMLElement).focus();
    document.getElementsByTagName("input")[0].focus();
  }

  async sendText() {
    if (!this.inputValue) return;
    const text = this.inputValue;
    this.inputValue = '';
    // WORK AROUND HG suppression voir slack https://jovodevs.slack.com/archives/C82DKJ7T5/p1615399345075800
    const request = this.$client.createRequest({ type: RequestType.Text, body: {text}});
    return request.send({body: JSON.stringify(request)});

  }

  private onRequest(req: WebRequest) {
    if( !this.clicked )
      (this.$refs.input as HTMLElement).focus();
    this.ssmlHandler.stop();
  }

  private  onSpeechSpeak(){
    this.micOn = false;
    this.$client.stopInputRecording();
  }

  private  endSSMLSpeak(){
    this.micOn = true;
    this.$client.startInputRecording();
    }
  private  startReco(){
    this.micOn = true;
  }

  private  timeOutReco(){
    this.micOn = false;
  }

  private  stopReco(){
    this.micOn = false;
  }

  private  endReco(){
    this.micOn = false;
  }

  private  errorReco(){
    this.micOn = false;
  }

  private  silenceReco(){
    this.speakOn = false;
  }

  private  speakReco(){
    this.speakOn = true;
  }

  onClick(event:any) {
    event.stopPropagation();
    document.getElementsByTagName("input")[0].blur();
    if(!this.clicked){
      this.clicked = true;
      this.$client.startInputRecording();
    }else{
      this.ssmlHandler.stop();
      if(this.$client.$speechRecognizer.isRecording){
        this.$client.stopInputRecording();
        }
      else{
        this.$client.startInputRecording();
      }
    }
  }

  private async onKeyDown(event: KeyboardEvent) {
    if (event.key === ' ') {
      window.addEventListener('keyup', this.onKeyUp);
      await this.$client.startInputRecording();
    }
  }

  private async onKeyUp(event: KeyboardEvent) {
    if (event.key === ' ') {
      window.removeEventListener('keyup', this.onKeyUp);
      this.$client.stopInputRecording();
    }
  }

  private onAction(action: Action) {
    // c'est ici qu'on lance la synthèse malgré que la config est à false
    switch (action.type) {
      case ActionType.Speech: {
        if (this.clicked){
          const { ssml, plain, displayText } = action as SpeechAction;
          this.ssmlHandler.handleSSML(ssml || plain || displayText || '');
        }

        //const speech = new SpeechSynthesisUtterance("displayText");
        //window.speechSynthesis.speak(speech);
      }
    }
  }

}
